"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
const mobx_1 = require("mobx");
// key for the default error to set/get
const DEFAULT_ERR = 'default';
class BaseStore {
    constructor({ loadingDebounce = 0 } = {}) {
        // debounced observable property when loading for small periods of time
        this.showLoading = false;
        this.errors = new Map();
        // we delay this reaction for one event loop tick
        // this is because `reaction` starts observing `isLoading`, which is very
        // likely class initialized (`@oservable isLoading = false`), and is called
        // _after_ this super constructor. mobx treats constructors as pseudo-actions,
        // unless data is observed (which this would). waiting a tick allows for the
        // subclass to do its initilizing, without triggering strict mode errors.
        setTimeout(() => {
            mobx_1.reaction(() => this.isLoading, (isLoading) => (this.showLoading = isLoading), {
                delay: loadingDebounce,
                fireImmediately: true,
            });
        }, 0);
    }
    getError(key) {
        return this.errors.get(key);
    }
    getErrorMessage(key) {
        const error = this.getError(key);
        if (error) {
            if (typeof error === 'string') {
                return error;
            }
            return error.message;
        }
        return undefined;
    }
    get error() {
        return this.getError(DEFAULT_ERR);
    }
    get errorMessage() {
        return this.getErrorMessage(DEFAULT_ERR);
    }
    get allErrors() {
        return [...this.errors.values()];
    }
    get anyError() {
        const errors = this.allErrors;
        if (errors.length > 0) {
            return errors[0];
        }
        return undefined;
    }
    get anyErrorMessage() {
        const error = this.anyError;
        if (error) {
            if (typeof error === 'string') {
                return error;
            }
            return error.message;
        }
        return undefined;
    }
    setError(...args) {
        if (args.length === 2 && typeof args[0] === 'string') {
            this.errors.set(args[0], args[1]);
        }
        else {
            this.errors.set(DEFAULT_ERR, args[0]);
        }
    }
    errorSetter(key) {
        // curry function, useful for createAction(_, this.errorSetter('myErr'), _)
        return (err) => this.setError(key, err);
    }
    clearError(key) {
        if (typeof key === 'string') {
            this.errors.delete(key);
        }
        else {
            this.errors.delete(DEFAULT_ERR);
        }
    }
    clearErrors() {
        this.errors.clear();
    }
}
__decorate([
    mobx_1.observable,
    __metadata("design:type", Boolean)
], BaseStore.prototype, "showLoading", void 0);
__decorate([
    mobx_1.observable,
    __metadata("design:type", Object)
], BaseStore.prototype, "errors", void 0);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BaseStore.prototype, "error", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BaseStore.prototype, "errorMessage", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BaseStore.prototype, "allErrors", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BaseStore.prototype, "anyError", null);
__decorate([
    mobx_1.computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], BaseStore.prototype, "anyErrorMessage", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object]),
    __metadata("design:returntype", void 0)
], BaseStore.prototype, "setError", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], BaseStore.prototype, "clearError", null);
__decorate([
    mobx_1.action.bound,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], BaseStore.prototype, "clearErrors", null);
exports.BaseStore = BaseStore;
exports.default = BaseStore;
//# sourceMappingURL=base-store.js.map